export default "<div *ngIf=\"isLoading | async\" class=\"loading\">Loading&#8230;</div>\r\n<router-outlet></router-outlet>";